import React from 'react';
import { FormikProps, withFormik } from 'formik';

import { emailSchema } from '@/services/validators/email';
import { FormContents, Values } from './FormContents';

export type { Values } from './FormContents';

type OuterProps = {
  initialEmail: string;
  isDisabled: boolean;
  onSubmit: (values: Values) => void;
  // Turnstile 関連
  turnstileError: string;
  turnstileLoading: boolean;
  onTurnstileSuccess: (token: string) => void;
  onTurnstileError: () => void;
};

export const ActivationStart = withFormik<OuterProps, Values>({
  mapPropsToValues: ({ initialEmail }) => ({
    email: initialEmail,
    ignoreTurnstile: false,
  }),
  validationSchema: emailSchema,
  handleSubmit: (values, { props, setSubmitting }) => {
    props.onSubmit(values);
    setSubmitting(false);
  },
})(
  // enhanced form
  ({
    errors,
    handleChange,
    handleSubmit,
    isDisabled = false,
    touched,
    values,
    turnstileError,
    turnstileLoading,
    onTurnstileSuccess,
    onTurnstileError,
  }: OuterProps & FormikProps<Values>) => {
    return (
      <FormContents
        errors={errors}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        isDisabled={isDisabled}
        touched={touched}
        values={values}
        turnstileError={turnstileError}
        turnstileLoading={turnstileLoading}
        onTurnstileSuccess={onTurnstileSuccess}
        onTurnstileError={onTurnstileError}
      />
    );
  },
);
